export default "__VITE_ASSET__DAMfG6q4__"